exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mainfooterlayout[data-v-60fa8457]{margin-bottom:36px;display:-ms-grid;display:grid;-ms-grid-rows:auto;grid-template-rows:auto;row-gap:18px}@media screen and (min-width:900px){.mainfooterlayout[data-v-60fa8457]{-ms-grid-columns:(1fr)[2];grid-template-columns:repeat(2,1fr);grid-gap:18px}}@media screen and (min-width:1110px){.mainfooterlayout[data-v-60fa8457]{-ms-grid-columns:(1fr)[3];grid-template-columns:repeat(3,1fr);grid-gap:0 18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60fa8457","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/modules/modulemain/components/mainfooterlayout/MainFooterLayout.vue
// module id = d6e9b93b2d2565869e46
// module chunks = 0